<template>
  <div class="card">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-sm-8">
          <i class="bx bx-send"></i>
          <b>Invite employee by employee id</b>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <validationObserver ref="inviteEmpForm" tag="form">
            <form @submit.prevent="onInviteEmployeeSubmit">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">Employee ID</label>
                <div class="col-md-7">
                  <validationProvider
                    v-slot="{ errors }"
                    ref="employeeid"
                    name="Employee ID"
                    :rules="{
                      required: true,
                      duplicateName: [
                        isDuplicate,
                        'Already existing this user in system. please use search.',
                      ],
                      notfoundValue: [
                        isEmployeeFounded,
                        'Not found this employee id in system',
                      ],
                    }"
                  >
                    <input
                      id="employeeid"
                      name="employeeid"
                      v-model="input.employee_id"
                      type="number"
                      class="form-control"
                      placeholder="Employee ID"
                      maxlength="30"
                      :class="{
                        'is-invalid': errors && errors.length,
                        'is-valid':
                          !(errors && errors.length) && input.employee_id,
                      }"
                      v-on:keyup="onValidateEmployeeId($event)"
                    />
                    <div
                      v-if="errors && errors.length"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
                <div class="col-md-2">
                  <button
                    type="submit"
                    class="btn btn-success btn-sm waves-effect"
                  >
                    Invite
                  </button>
                </div>
              </div>
            </form>
          </validationObserver>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-sm-12 text-center">
          <span>OR</span>
        </div>
      </div>
      <hr />
      <div class="row mb-2">
        <div class="col-sm-8">
          <i class="bx bx-send"></i>
          <b>Invite employee by email</b>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <validationObserver ref="inviteEmpByEmailForm" tag="form">
            <form @submit.prevent="onInviteEmployeeByEmailSubmit">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">Email</label>
                <div class="col-md-7">
                  <validationProvider
                    v-slot="{ errors }"
                    ref="email"
                    name="Email"
                    :rules="{
                      required: true,
                      duplicateName: [
                        isDuplicateByEmail,
                        'Already existing this user in system. please use search.',
                      ],
                      notfoundValue: [
                        isEmployeeByEmailFounded,
                        'Not found this employee id in system',
                      ],
                      validateEmployee: [
                        isEmployee,
                        'This email is not an employee.',
                      ],
                    }"
                  >
                    <input
                      id="email"
                      name="email"
                      v-model="input.email"
                      type="email"
                      class="form-control"
                      placeholder="Email"
                      :class="{
                        'is-invalid': errors && errors.length,
                        'is-valid': !(errors && errors.length) && input.email,
                      }"
                      v-on:keyup="onValidateEmail($event)"
                    />
                    <div
                      v-if="errors && errors.length"
                      class="invalid-feedback"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
                <div class="col-md-2">
                  <button
                    type="submit"
                    class="btn btn-success btn-sm waves-effect"
                  >
                    Invite
                  </button>
                </div>
              </div>
            </form>
          </validationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import groupService from "@/helpers/service/group-provider";
import userService from "@/helpers/service/user-provider";
import { eventBus } from "@/main.js";

import {
  userComputed,
  userMethods,
  applicationComputed,
} from "@/state/helpers";

export default {
  props: {
    applicationId: {
      type: String,
      default: "",
    },
    groupId: {
      type: String,
      default: "",
    },
    groupUsers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      toggle: false,
      input: {
        employee_id: "",
        email: "",
      },
      isDuplicate: false,
      isEmployeeFounded: false,
      isDuplicateByEmail: false,
      isEmployeeByEmailFounded: false,
      isEmployee: false,
    };
  },
  computed: {
    ...userComputed,
    ...applicationComputed,
  },
  watch: {},
  mounted() {},
  methods: {
    ...userMethods,
    async onInviteEmployeeSubmit() {
      this.$refs.inviteEmpForm.validate().then(async (result) => {
        if (result) {
          var body = {
            employee_id: this.input.employee_id.trim(),
          };
          //("body", body);
          // console.log(
          //   "GET_APPLICATION_SELECTED",
          //   this.GET_APPLICATION_SELECTED.id
          // );
          let result = await groupService.InviteEmployeeAsync(
            this.GET_APPLICATION_SELECTED.id,
            this.groupId,
            body
          );
          if (result.status === 201) {
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1500,
            });

            this.input.employee_id = "";
            // this.$refs.hideUser.click();
            this.$emit("hidden");
            await this.$emit("getGroupUsersSelected", this.groupId);
            this.isEmployeeFounded = false;
          } else {
            if (result.response.status === 404) this.isEmployeeFounded = true;
            else eventBus.$emit("error-modal", result.response.data.message);
          }
        }
      });
    },
    async onInviteEmployeeByEmailSubmit() {
      this.$refs.inviteEmpByEmailForm.validate().then(async (result) => {
        if (result) {
          var emailRegex =
            /^[A-Za-z0-9._%+-]+@ofm.co.th|@officemate.co.th|@b2s.co.th|@central.co.th$/gm;

          if (!emailRegex.test(this.input.email.trim())) {
            this.isEmployee = true;
            return;
          }

          var body = {
            email: this.input.email.trim(),
          };
          // console.log("body", body);
          // console.log(
          //   "GET_APPLICATION_SELECTED",
          //   this.GET_APPLICATION_SELECTED.id
          // );
          let result = await groupService.InviteEmployeeByEmailAsync(
            this.GET_APPLICATION_SELECTED.id,
            this.groupId,
            body
          );
          if (result.status === 201) {
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1500,
            });

            this.input.email = "";
            // this.$refs.hideUser.click();
            this.$emit("hidden");
            await this.$emit("getGroupUsersSelected", this.groupId);
            this.isEmployeeByEmailFounded = false;
          } else {
            if (result.response.status === 404)
              this.isEmployeeByEmailFounded = true;
            else eventBus.$emit("error-modal", result.response.data.message);
          }
        }
      });
    },
    async onValidateEmployeeId() {
      if (
        !(
          this.input.employee_id.trim() === "" ||
          this.input.employee_id.trim() === null ||
          this.input.employee_id.trim() === undefined
        )
      ) {
        this.isEmployeeFounded = false;
        let params = new URLSearchParams();
        params.append("crc_id", this.input.employee_id.trim());

        let result = await userService.headUserAsync(params);
        if (result.status === 200) {
          this.isDuplicate = true;
        } else if (result.response.status === 404) {
          this.isDuplicate = false;
        } else {
          if (result.response.data.message) {
            eventBus.$emit("error-modal", result.response.data.message);
          } else {
            eventBus.$emit("error-modal", "Bad request: Unknow error");
          }
        }
      }
    },
    async onValidateEmail() {
      if (
        !(
          this.input.email.trim() === "" ||
          this.input.email.trim() === null ||
          this.input.email.trim() === undefined
        )
      ) {
        this.isEmployee = false;
        this.isEmployeeByEmailFounded = false;
        this.isDuplicateByEmail = false;
        var emailRegex =
          /^[A-Za-z0-9._%+-]+@ofm.co.th|@officemate.co.th|@b2s.co.th|@central.co.th$/gm;

        if (!(await emailRegex.test(this.input.email.trim()))) {
          // console.log(
          //   "test test ",
          //   this.input.email.trim(),
          //   emailRegex.test(this.input.email.trim())
          // );
          this.isEmployee = true;
        } else {
          console.log("success");
          let params = new URLSearchParams();
          params.append("email", this.input.email.trim());

          let result = await userService.headUserAsync(params);
          if (result.status === 200) {
            this.isDuplicateByEmail = true;
          } else if (result.response.status === 404) {
            this.isDuplicateByEmail = false;
          } else {
            if (result.response.data.message) {
              eventBus.$emit("error-modal", result.response.data.message);
            } else {
              eventBus.$emit("error-modal", "Bad request: Unknow error");
            }
          }
        }
      }
    },
    onHide() {
      this.$emit("hide");
    },
  },
};
</script>
